import { connect } from 'react-redux';
import { Menu } from './appDashBoard-view';
import { getInvoices, getInvoiceTrend } from '../../reducers/invoices';
import { getEntities } from '../../reducers/entities';
import { getRecurring } from '../../reducers/recurring';

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        dashboard: state.auth.userDashBoard,
        company: state.companies.company,
        invoices: state.invoices.invoices,
        entities: state.entities.entities,
        recurring: state.recurring.recurring,
        invoiceTrend: state.invoices.trend,
        selectedCompanyId: state.companies.selectedCompanyId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        dispatchGetInvoices: () => dispatch(getInvoices()),
        dispatchGetEntities: () => dispatch(getEntities()),
        dispatchGetRecurring: () => dispatch(getRecurring('invoices')),
        dispatchGetInvoiceTrend: () => dispatch(getInvoiceTrend(6)),
    };
};

const menu = connect(mapStateToProps, mapDispatchToProps)(Menu);

export default menu;
